import React, { FC, useState, useEffect } from "react";
import {
  Container 
} from './styles'
import {
  calculateScales,
  createPercentageArrays,
  generateYScale,
  convertToPercentageCpu,
  convertToUsageValues,
  generateUsageScale,
} from '../metrics/metricFuncs'
import { instanceService } from "../../../../../api";
import MetricsChart from "../../../../../components/metrics";
import { useTranslation } from "react-i18next";
import { TopProgress } from "../../../../../components";

type MetricsProps = {
  instance:any,
}


const Metrics:FC<MetricsProps> = ({instance}) => {
  const [t] = useTranslation()
  const vcpus = Number(instance?.flavor?.vcpus)
  const memoryMb = Number(instance?.flavor?.memory_mb)
  const memoryGb = Number(instance?.flavor?.memory_gb)
  const cpuCapacity = Number.isFinite(vcpus) && vcpus > 0 ? vcpus * 100 : undefined
  const ramCapacity = Number.isFinite(memoryMb) && memoryMb > 0
    ? memoryMb
    : Number.isFinite(memoryGb) && memoryGb > 0
      ? memoryGb * 1024
      : undefined

  const [cpuMetrics, setCpuMetrics] = useState<any[]>([])
  const [ramMetrics, setRamMetrics] = useState<any[]>([])
  const [networkMetrics, setNetworkMetrics] = useState<any[]>([])
  const [networkMetricsOut, setNetworkMetricsOut] = useState<any[]>([])
  const [scales, setScales] = useState<any[]>([])
  const [cpuScales, setCpuScales] = useState<any[]>([])
  const [ramScales, setRamScales] = useState<any[]>([])
  const [preLoadMetrics, setPreLoadMetrics] = useState<boolean>(true)
  const [loadNetwork, setLoadNetwork] = useState<boolean>(false)
  const [loadCpu, setLoadCpu] = useState<boolean>(false)
  const [loadRam, setLoadRam] = useState<boolean>(false)

  const applyCpuMetrics = (measures:any[] = []) => {
    //@ts-ignore
    setCpuScales(generateYScale(measures, cpuCapacity))
    setCpuMetrics(convertToPercentageCpu(measures, cpuCapacity))
  }

  const applyRamMetrics = (measures:any[] = []) => {
    setRamScales(generateUsageScale(measures, ramCapacity))
    setRamMetrics(convertToUsageValues(measures, ramCapacity))
  }

  const applyNetworkMetrics = (measures:any[] = [], type?:any) => {
    setScales(calculateScales(measures))
    setNetworkMetrics(createPercentageArrays(measures, type === '2' ? 'bytes_in' : 'packets_in'))
    setNetworkMetricsOut(createPercentageArrays(measures, type === '2' ? 'bytes_out' : 'packets_out'))
  }

  const _updateMetrics = (hours:any=1) => {
    Promise.all([
      instanceService.getMetrics(instance?.id, {
        hours:'1',
        metric: 'cpu_util'
      }),
      instanceService.getMetrics(instance?.id, {
        hours:'1',
        metric: 'ram_usage'
      }),
      instanceService.getMetrics(instance?.id, {
        hours:hours,
        metric: 'interface_traffic'
      })
    ])
      .then(([cpuRes, ramRes, networkRes]) => {
        applyCpuMetrics(cpuRes?.data?.measures)
        applyRamMetrics(ramRes?.data?.measures)
        applyNetworkMetrics(networkRes?.data?.measures, '2')
      })
      .catch((err) => {
        console.log('err',err);
      })
      .finally(() => {
        setPreLoadMetrics(false)
      })
  }

  const updateCpu = (hours:any=1) => {
    setLoadCpu(true)
    instanceService.getMetrics(instance?.id, {
      hours:hours,
      metric: 'cpu_util'
    })
    .then((res:any) => {
      applyCpuMetrics(res?.data?.measures)
    })
    .catch((err) => {
      console.log('err',err);
    })
    .finally(() => {
      setLoadCpu(false)
    })
  }

  const updateRam = (hours:any=1) => {
    setLoadRam(true)
    instanceService.getMetrics(instance?.id, {
      hours:hours,
      metric: 'ram_usage'
    })
    .then((res:any) => {
      applyRamMetrics(res?.data?.measures)
    })
    .catch((err) => {
      console.log('err',err);
    })
    .finally(() => {
      setLoadRam(false)
    })
  }

  const updateNetworks = (hours:any=1, type?:any) => {
    setLoadNetwork(true)
    instanceService.getMetrics(instance?.id, {
      hours:hours,
      metric: 'interface_traffic'
    })
    .then((res) => {
      applyNetworkMetrics(res?.data?.measures, type)
    })
    .catch((err) => {
      console.log('err',err?.response?.data);
    })
    .finally(() => {
      setLoadNetwork(false)
    })
  }
  useEffect(() => {
    _updateMetrics()
  },[])
  if(preLoadMetrics) return <TopProgress loading={preLoadMetrics}/>
  // if(networkMetrics?.length === 0 && cpuMetrics?.length === 0) return(
  //   <Container>
  //     <BodyDefault>
  //       {t("HAS_NO_METRICS_YET")}
  //     </BodyDefault>
  //   </Container>
  // )
  return(
    <Container>
      {/* {networkMetrics?.length > 0 && networkMetricsOut?.length > 0 && */}
        <MetricsChart
          updateData={updateNetworks}
          title={t("NETWORK_METRIC")}
          scales={scales}
          data={networkMetrics}
          dataSecond={networkMetricsOut}
          loading={loadNetwork}
        />
      {/* } */}
      {/* {cpuMetrics?.length > 0 && */}
        <MetricsChart
          updateData={updateCpu}
          title={t("CPU_USAGE")}
          isCpu
          cpuLabel="CPU"
          data={cpuMetrics}
          scalesCpu={cpuScales}
          loading={loadCpu}
        />
      {/* } */}
        <MetricsChart
          updateData={updateRam}
          title={t("RAM_USAGE")}
          isCpu
          cpuLabel={t("RAM_USAGE")}
          data={ramMetrics}
          scalesCpu={ramScales}
          loading={loadRam}
        />
    </Container>
  )
}

export default Metrics
